/* eslint-disable no-useless-escape */
import log from "loglevel";

var addrparser = require("address-rfc2822");

export const validPhoneNumberRegex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
export const validFirstAndLastName = /^[a-zA-Z]+(?:[-'\s][a-zA-Z]+)*$/;
export const validEmailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const validMultipleEmailRegex =
    /^(?:(?:[^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(?:([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(;\s*(?:(?:[^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((?:\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(?:([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))*$/;
export function validArray(array) {
    return !(!array || array.constructor !== Array || array.length === 0);
}
export function validObject(obj) {
    return !(!obj || obj === null);
}
export function assertString(str, noValidateTrim) {
    if (validObject(str)) {
        if (noValidateTrim) {
            return str !== "";
        } else {
            return String(str).trim() !== "";
        }
    }
    return false;
}


/**
 *
 * @param obj
 * @returns {boolean} if the object is null or undefined
 */
export function assertObjectValue(obj) {
    return !(!obj || obj === null || obj === undefined);
}

export function assertArray(array) {
    return validArray(array);
}

export function assertObject(obj) {
    return validObject(obj);
}
export function validateMultipleEmails(strEmails) {
    if (assertString(strEmails)) {
        const emails = strEmails.split(";");

        if (assertArray(emails)) {
            let valid = true;
            emails
                .filter((e) => assertString(e))
                .forEach((e) => {
                    try {
                        const addresses = addrparser.parse(e);
                        if (assertArray(addresses)) {
                            const address = addresses[0];
                            if (!assertString(address.address)) {
                                valid = valid && true;
                            }
                        }
                    } catch (e) {
                        log.error("validateMultipleEmails", e);
                        valid = false;
                    }
                });
            return valid;
        }
    }
    return false;
}



